module.exports = __webpack_public_path__ + "img/img61.c90087ca.png";